import axios from './http'
const api = {
  danmu : {
    //弹幕列表
    list: params => axios.get("/danmu/list",{params:params}),
    //统计
    statisticsList : params => axios.get("/statistics/info/month",{params:params}),
    // 日统计
    statisticsDayList : params => axios.get("/statistics/info/day",{params:params})
  }
};
export default api;



// WEBPACK FOOTER //
// ./src/api/api.js